export default __webpack_public_path__ + "static/media/aboutus_banner.61f9ff4d.jpg";